export { default } from './PrefecturesList';
